module.exports = __webpack_public_path__ + "static/img/MV@2x.c691d4f7.jpg";